"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredictionQuestionResult = exports.PredictionQuestionStatus = void 0;
var PredictionQuestionStatus;
(function (PredictionQuestionStatus) {
    PredictionQuestionStatus["ACTIVE"] = "ACTIVE";
    PredictionQuestionStatus["INACTIVE"] = "INACTIVE";
})(PredictionQuestionStatus || (exports.PredictionQuestionStatus = PredictionQuestionStatus = {}));
var PredictionQuestionResult;
(function (PredictionQuestionResult) {
    PredictionQuestionResult["LEFT"] = "LEFT";
    PredictionQuestionResult["RIGHT"] = "RIGHT";
    PredictionQuestionResult["DRAW"] = "DRAW";
    PredictionQuestionResult["ERROR"] = "ERROR";
    PredictionQuestionResult["EXPIRED"] = "EXPIRED";
})(PredictionQuestionResult || (exports.PredictionQuestionResult = PredictionQuestionResult = {}));
//# sourceMappingURL=question.js.map